export function shuffle(arr: any[]) {
    let newArr = [...arr];
    let i = newArr.length - 1;
    for (i; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
  }